import { render } from "./FieldLabel.vue?vue&type=template&id=5f45b730&scoped=true"
import script from "./FieldLabel.vue?vue&type=script&lang=ts"
export * from "./FieldLabel.vue?vue&type=script&lang=ts"

import "./FieldLabel.vue?vue&type=style&index=0&id=5f45b730&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f45b730"

export default script